import { DateTime } from "luxon";

export const PERSON_TIMELINE_PREVIEW_MONTHS_PRIMARY = 6;
export const PERSON_TIMELINE_PREVIEW_MONTHS_FALLBACK = 12;
export const PERSON_TIMELINE_PREVIEW_MAX_ROWS = 10;
export const PERSON_TIMELINE_PREVIEW_TIMEZONE = "America/Chicago";

export function getPersonTimelinePreviewDateRange(
  months: number,
  referenceDate?: string
): { from: string; to: string } {
  const today = (
    referenceDate
      ? DateTime.fromISO(referenceDate, { zone: PERSON_TIMELINE_PREVIEW_TIMEZONE })
      : DateTime.now().setZone(PERSON_TIMELINE_PREVIEW_TIMEZONE)
  ).startOf("day");
  return {
    from: today.minus({ months }).toISODate()!,
    to: today.toISODate()!
  };
}
